import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { MenuIcon, PhoneIcon, XIcon } from 'lucide-react';
import { company, services } from '../data/site';
const navItems = [{
  to: '/',
  label: 'Accueil',
  fullLabel: 'Accueil'
}, ...services.map(s => ({
  to: s.path,
  label: s.shortLabel,
  fullLabel: s.label
})), {
  to: '/contact',
  label: 'Contact',
  fullLabel: 'Contact'
}];
export function Header() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);
  return <header className="sticky top-0 z-40 w-full border-b border-line bg-white/95 backdrop-blur" data-id="element-85" data-mp="31d0715bese3m">
      <div className="mx-auto flex max-w-content items-center gap-4 px-5 py-3 lg:px-8 lg:py-4" data-id="element-86" data-mp="36a0ar9ksd4rk">
        <Link to="/" className="flex items-center gap-3" aria-label={`${company.name} — retour à l'accueil`} data-id="element-87" data-mp="3bb66lg9qt85b">
          <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-navy-800 lg:h-11 lg:w-11" data-id="element-88" data-mp="3f9dmk8wdu5fg">
            <span className="font-display text-base font-extrabold text-ember-300 lg:text-lg" data-id="element-89" data-mp="2rlrjpg6fbp1h">
              19
            </span>
          </span>
          <span className="leading-tight" data-id="element-90" data-mp="2mng7iysnp2g3">
            <span className="block whitespace-nowrap font-display text-[1.05rem] font-extrabold tracking-tight text-navy-800 lg:text-lg" data-id="element-91" data-mp="2moht3x7at7c2">
              Chauffe Plus 19
            </span>
            <span className="hidden whitespace-nowrap text-[0.68rem] font-medium uppercase tracking-[0.12em] text-navy-400 sm:block" data-id="element-92" data-mp="3fdezp325dfoz">
              Chauffage · Ramonage · Plomberie
            </span>
          </span>
        </Link>

        <nav className="ml-auto hidden items-center gap-1 lg:flex" aria-label="Navigation principale" data-id="element-93" data-mp="30mpr88g2meot">
          {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} title={item.fullLabel} className={({
          isActive
        }) => ['whitespace-nowrap rounded-lg px-3 py-2 text-[0.94rem] font-medium transition-colors duration-150 ease-out', isActive ? 'bg-navy-50 text-navy-700' : 'text-navy-500 hover:bg-navy-50 hover:text-navy-700'].join(' ')} data-id="element-94" data-mp="1yadca8zmj54">
              {item.label}
            </NavLink>)}
        </nav>

        <a href={company.phoneHref} className="ml-auto inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-xl bg-ember-500 px-3.5 py-2.5 font-display text-sm font-bold text-white transition-colors duration-150 ease-out hover:bg-ember-600 lg:ml-4 lg:px-5 lg:text-[0.95rem]" data-id="element-95" data-mp="1cof6gynsk1u9">
          <PhoneIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-96" data-mp="2t2nfdqfn2cnf" />
          <span className="hidden sm:inline" data-id="element-97" data-mp="2y200a5my99nd">{company.phone}</span>
          <span className="sm:hidden" data-id="element-98" data-mp="2y18grt6mn2dg">Appeler</span>
        </a>

        <button type="button" onClick={() => setOpen(v => !v)} className="-mr-1 inline-flex h-11 w-11 items-center justify-center rounded-xl border border-line text-navy-700 transition-colors duration-150 ease-out hover:bg-surface lg:hidden" aria-expanded={open} aria-controls="menu-mobile" aria-label={open ? 'Fermer le menu' : 'Ouvrir le menu'} data-id="element-99" data-mp="mdva2zcokail">
          {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-100" data-mp="1578vodui74lj" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-101" data-mp="1059r50n121n0" />}
        </button>
      </div>

      {open && <div id="menu-mobile" className="border-t border-line bg-white px-5 pb-5 pt-2 lg:hidden" data-id="element-102" data-mp="1f2k98su6e5rp">
          <nav className="flex flex-col" aria-label="Navigation mobile" data-id="element-103" data-mp="3guowhr0qcew3">
            {navItems.map(item => <NavLink key={item.to} to={item.to} end={item.to === '/'} className={({
          isActive
        }) => ['border-b border-line/70 py-3.5 font-display text-base font-semibold transition-colors duration-150 ease-out', isActive ? 'text-ember-500' : 'text-navy-700'].join(' ')} data-id="element-104" data-mp="3bw5bptxvh95b">
                {item.fullLabel}
              </NavLink>)}
          </nav>
          <a href={company.emailHref} className="mt-4 block text-sm font-medium text-navy-400" data-id="element-105" data-mp="1k9gydmtrthmo">
            {company.email}
          </a>
        </div>}
    </header>;
}